export const authentication = {
  isAuthenticated: () => {
    if (localStorage.isAuthenticated === undefined) return false;
    return JSON.parse(localStorage.isAuthenticated);
  },
  setAuthed: (value) => { localStorage.isAuthenticated = value; },
};
